{
  "sources": "Makers whose name parts shops spell in more than one way, collected from the shops the catalogue reads (October 2026). Case, spaces, punctuation and accents never count, so only other words need a spelling here.",
  "makers": [
    { "name": "BMW", "spellings": ["BMW AG", "Bayerische Motoren Werke"] },
    { "name": "Bosch", "spellings": ["Robert Bosch"] },
    { "name": "febi bilstein", "spellings": ["febi"] },
    { "name": "Hengst", "spellings": ["Hengst Filter"] },
    { "name": "Lemförder", "spellings": ["Lemfoerder"] },
    { "name": "Mahle", "spellings": ["Mahle Original"] },
    { "name": "MANN-FILTER", "spellings": ["MANN", "Mann Filter"] },
    { "name": "TRUCKTEC AUTOMOTIVE", "spellings": ["Trucktec"] },
    { "name": "Victor Reinz", "spellings": ["Reinz"] }
  ]
}
